@if (!disabled()) {
   <button
      #button
      type="button"
      hisImage="DOWNLOAD"
      class="transparent"
      (click)="downloadFile($event)"
      [title]="'common.downloadOf' | hisUi: value().name"
      [disabled]="disabled()">
   </button>
}
